import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class IntraOne_ds_get_licenseplate_by_lookupcode_warehousenameService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lookupcode: string, warehouse_name: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookupcode)) {
      $missingRequiredInParams.push('\'lookupcode\'');
    }
    if (isNil($inParams.warehouse_name)) {
      $missingRequiredInParams.push('\'warehouse_name\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/datasources/ds_get_licenseplate_by_lookupcode_warehousename/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lookupcode: string, warehouse_name: string    }) {
        if(isNil($inParams.lookupcode)) {
          return true; 
        }
        if(isNil($inParams.warehouse_name)) {
          return true; 
        }
      return false;
    }
}
